import { registerSystem, System } from "aframe";


export interface LocationSystem extends System
{
	addChannel(id : string, entry : string) : void;
	removeChannel(id : string, entry? : string) : void;
}

interface LocationSystemImpl extends LocationSystem
{
	data : {
		localStorage : string;
	};
	channels : { [id : string] : string };
	apply() : void;
}

registerSystem("location", {

	schema : {
		localStorage : { type : "string", default : "current-location" }
	},
	
	init(this : LocationSystemImpl)
	{
		this.channels = {};
	},

	apply(this : LocationSystemImpl)
	{
		let sep = "#", hash = "";
		for(let channel in this.channels)
		{
			/* #channel:entry&channel:entry */
			const entry = this.channels[channel];
			hash += sep + channel.replaceAll(/[#@&%]/g, encodeURIComponent);
			if(entry)
				hash += "@" + entry.replaceAll(/[#@&%]/g, encodeURIComponent);
			sep = '&';
		}
		const newLocation = new URL(window.location.href);
		newLocation.hash = hash;
		if(this.data.localStorage)
			window.localStorage.setItem(this.data.localStorage, hash);
		setTimeout( () => window.history.replaceState({}, '', newLocation.href) );
	},

	addChannel(this : LocationSystemImpl, id : string, entry : string)
	{
		this.channels[id] = entry;
		this.apply();
	},

	removeChannel(this : LocationSystemImpl, where : string, entry? : string)
	{
		if(!(where in this.channels)) return;
		if(entry && (this.channels[where] != entry)) return;
		delete this.channels[where];
		this.apply();
	}

})